__turbopack_context__.v({
  "content": "styles-module-scss-module__LA66Eq__content",
  "cover": "styles-module-scss-module__LA66Eq__cover",
  "date": "styles-module-scss-module__LA66Eq__date",
  "header": "styles-module-scss-module__LA66Eq__header",
  "header__nav": "styles-module-scss-module__LA66Eq__header__nav",
  "header__row": "styles-module-scss-module__LA66Eq__header__row",
  "localeSwitcher": "styles-module-scss-module__LA66Eq__localeSwitcher",
  "localeSwitcher__btn": "styles-module-scss-module__LA66Eq__localeSwitcher__btn",
  "outer": "styles-module-scss-module__LA66Eq__outer",
  "share": "styles-module-scss-module__LA66Eq__share",
  "title": "styles-module-scss-module__LA66Eq__title",
  "views": "styles-module-scss-module__LA66Eq__views",
  "wrapper": "styles-module-scss-module__LA66Eq__wrapper",
});
